import store from '@/store';

const hubSpotClass = 'hubspot-visible';
let hubSpotTimeout: ReturnType<typeof setTimeout>;

export function showHubSpotPopup() {
    hubSpotTimeout = setTimeout(() => {
        document.body.classList.add(hubSpotClass);
    }, store.state.options.hubspot_popup * 1000);
}

export function hideHubSpotPopup() {
    clearTimeout(hubSpotTimeout);
    document.body.classList.remove(hubSpotClass);
}
